// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"a3c649af","309":"f4c259fa","672":"a3c649af","742":"f4c259fa"}[chunkId] + ".chunk.css";
};